import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

const PricingRedirect = () => {
  const isAuthenticated = useSelector(
    (state: RootState) => state.auth.isAuthenticated
  );

  if (isAuthenticated) {
    return <Navigate to="/pricing" replace />;
  }

  const params = new URLSearchParams();
  params.set('redirect', '/pricing');

  return <Navigate to={`/auth?${params.toString()}`} replace />;
};

export default PricingRedirect;
